import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login'
import confirmPin from '../components/confirmPin'
import CompleteRegistration from '../components/CompleteRegistration'
import Transactions from '../components/Transactions'
import Subscriptions from '../components/Subscriptions'
import WebhookLogs from '../components/WebhookLogs'
import Telemarketing from '../components/Telemarketing'
import ChangePassword from '../components/ChangePassword'
import AddSubscriber from '../components/AddSubscriber'
import ManageUsers from '../components/ManageUsers'
import EditUser from '../components/editUser'
import AuthenticationService from '../services/AuthenticationService'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err.name === 'NavigationDuplicated' ? err : Promise.reject(err))
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err.name === 'NavigationDuplicated' ? err : Promise.reject(err))
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: to => {
        if (!AuthenticationService.isUserLoggedIn()) {
          return '/login'
        } else {
          if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) {
            return '/telemarketing'
          }
          return '/transactions'
        }
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/confirmPin',
      name: 'confirmPin',
      component: confirmPin
    },
    {
      path: '/completeregistration',
      name: 'CompleteRegistration',
      component: CompleteRegistration
    },
    {
      path: '/transactions',
      name: 'Transactions',
      component: Transactions
    },
    {
      path: '/subscriptions',
      name: 'Subscriptions',
      component: Subscriptions
    },
    {
      path: '/webhookLogs',
      name: 'WebhookLogs',
      component: WebhookLogs
    },
    {
      path: '/telemarketing',
      name: 'Telemarketing',
      component: Telemarketing
    },
    {
      path: '/addsubscriber',
      name: 'AddSubscriber',
      component: AddSubscriber
    },
    {
      path: '/manageusers',
      name: 'ManageUsers',
      component: ManageUsers
    },
    {
      path: '/edituser',
      name: 'EditUser',
      component: EditUser
    },
    {
      path: '/changePassword',
      name: 'ChangePassword',
      component: ChangePassword
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js